import React from 'react'
import Image from 'next/image'
import { css, useTheme } from '@emotion/react'
import { Typography } from './'

function PartnerLogo({
    imageSrc,
    caption,
    customCaption,
    style,
    width = '100px',
    height = '100px',
    active = false
}) {
    const theme = useTheme()
    const colored = css`
        background: linear-gradient(
            45deg,
            #6366f1 0%,
            #a855f7 50%,
            #e74799 100%
        );
        background-repeat: no-repeat;
        border-radius: 100%;
        padding: 3px;
        ${style};
    `
    const solid = css`
        background-color: ${theme.colors.lighter};
        border-radius: 100%;
        padding: 3px;
        ${style};
    `
    return (
        <div className="flex flex-col items-center text-center">
            <div css={active ? colored : solid}>
                <div
                    className="rounded-full bg-white"
                    css={css`
                        width: ${width};
                        height: ${height};
                    `}
                >
                    {imageSrc && (
                        <div className="p-1">
                            <Image
                                alt={caption}
                                src={imageSrc}
                                width={width}
                                height={height}
                            />
                        </div>
                    )}
                </div>
            </div>
            {caption && (
                <Typography type="p" color="secondary" className="mt-4">
                    {caption}
                </Typography>
            )}
            {customCaption}
        </div>
    )
}

export default PartnerLogo
